import React, { useEffect, useState } from "react";
import OrderSummary from "../components/Cart/OrderSummary";
import { useDispatch, useSelector } from "react-redux";
import { clearCart, removeItem, updateItem } from "../redux/cart-items";
import MakePaymentModal from "../components/Payment/MakePaymentModal";
import { getCheckoutPayload } from "../utils/helperFunctions/cart";
import { doFinalCheckIn } from "../redux/final-checkln-process";
import Loader from "../components/Loader";
import CartItemSupplement from "../components/Cart/CartItemSupplement";
import CartItemStateroom from "../components/Cart/CartItemStateroom";
import PayStatusPopup from "./PayStatusPopup";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const Cart = () => {
  const dispatch = useDispatch();
  const payAmount = useSelector((state) => state.cart.total);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const bookingDetails = useSelector((state) => state.bookingValidation.data);
  const total = useSelector((state) => state.cart.total);
  const [showPaymentModal, setShowPaymentModal] = React.useState(false);
  const [cardDetails, setCardDetails] = React.useState({});
  const isLoading = useSelector((state) => state.finalChecklnProcess.isLoading);
  const [showPopup, setShowPopup] = useState(false);

  const handleRemoveItem = (title, type) => {
    dispatch(removeItem({ title: title, type: type }));
  };

  // const handleUpdateItem = (item) => {
  //   dispatch(updateItem(item));
  // };

  // const handleClearCart = () => {
  //   dispatch(clearCart());
  // };

  const handleIncrement = (title, type) => {
    dispatch(updateItem({ title, type, action: "increment" }));
  };

  const handleDecrement = (title, type) => {
    dispatch(updateItem({ title, type, action: "decrement" }));
  };

  const handleSubmitPayment = async () => {
    setShowPaymentModal(false);
    await getCheckoutPayload(
      bookingDetails,
      cartItems,
      cardDetails,
      payAmount
    ).then((res) => dispatch(doFinalCheckIn({ payload: res })));
  };

  const status = useSelector(
    (state) => state.finalChecklnProcess?.data?.status
  );
  const message = useSelector(
    (state) => state.finalChecklnProcess?.data?.message
  );

  useEffect(() => {
    if (status === "success" && message !== "No Upgradation has been done.") {
      setShowPopup(true);
      message && toast.success(message);
      dispatch(clearCart());
    }
    if (status === "failed") {
      setShowPopup(true);
      message && toast.error(message);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, message]);

  return (
    <div className="md:w-4/5 min-h-screen flex flex-col gap-5 p-4 md:flex-row md:justify-between md:mx-auto md:p-8">
      <div className="w-full md:w-3/4">
        <h1 className="text-2xl md:text-3xl font-bold text-mv-darkblue uppercase">
          My Cart
        </h1>
        <div className="py-4">
          {cartItems.length > 0 ? (
            cartItems.map((item) => {
              if (item.supplement) {
                return (
                  <CartItemSupplement
                    key={item.title}
                    item={item}
                    onRemove={handleRemoveItem}
                    onIncrement={handleIncrement}
                    onDecrement={handleDecrement}
                  />
                );
              } else {
                return (
                  <CartItemStateroom
                    key={item.title}
                    item={item}
                    onRemove={handleRemoveItem}
                    onIncrement={handleIncrement}
                    onDecrement={handleDecrement}
                  />
                );
              }
            })
          ) : (
            <div className="absolute left-0 right-0 m-auto">
              <h1 className="text-2xl text-center text-mv-darkblue font-semibold">
                Your cart is empty!
              </h1>
              <button className="bg-mv-darkblue text-white font-semibold p-2 w-fit rounded-lg absolute left-0 right-0 m-auto top-20">
                <Link to={`/?currentTab=Enhance Sailing`}>
                  Continue Shopping
                </Link>
              </button>
            </div>
          )}
        </div>
      </div>
      {cartItems.length > 0 && (
        <div className="w-full md:w-1/4">
          <OrderSummary
            setShowPaymentModal={setShowPaymentModal}
            items_count={cartItems.length}
            total={total}
          />
        </div>
      )}
      {showPaymentModal && (
        <MakePaymentModal
          handleSubmitPayment={handleSubmitPayment}
          setShowPaymentModal={setShowPaymentModal}
          setShowPopup={setShowPopup}
          setCardDetails={setCardDetails}
        />
      )}
      {showPopup && (
        <PayStatusPopup onClose={() => setShowPopup(false)} status={status} />
      )}
      {<Loader isLoading={isLoading} />}
    </div>
  );
};

export default Cart;
